// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2BSmV6PimDgTRL9XWNhvuK h3 {\n    margin-bottom: 30px;\n}\n\n._2BSmV6PimDgTRL9XWNhvuK .MuiIcon-root {\n    font-size: 20px;\n}\n\n/* material table heading */\n._2BSmV6PimDgTRL9XWNhvuK h6 {\n    font-size: 18px;\n    font-weight: 600;\n    color: #32445A;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "_2BSmV6PimDgTRL9XWNhvuK"
};
module.exports = exports;
